export default "__VITE_ASSET__2afdc30b__"